import { Flex, FlexProps, Text } from '@rover/kibble/core';

interface Props {
  sx?: FlexProps['sx'];
}
export default function NoReviewsBox({ sx }: Props): JSX.Element {
  return (
    <Flex
      width="100%"
      height="273px"
      background="secondary"
      justifyContent="center"
      alignItems="center"
      borderRadius="8px"
      sx={sx}
    >
      <Text size="100" fontWeight="semibold" textColor="tertiary">
        No available reviews
      </Text>
    </Flex>
  );
}
